import { render } from "./Remittance.vue?vue&type=template&id=4d6f0adc"
import script from "./Remittance.vue?vue&type=script&lang=js"
export * from "./Remittance.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Project\\METE_OUTLET_WEB\\METE_WEB\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__